import { Navigate } from "react-router-dom";
import { useApp } from "../../context/AppContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useApp();

  if (loading) return null;
  if (!user) return <Navigate to="/admin-login" replace />;
  return children;
}